import styled from "@emotion/styled";

import clouds from "@/../../hypetrain/static/img/about-clouds.jpg";
import founderSig from "@/../../hypetrain/static/img/founder-sig.jpg";
import nick from "@/../../hypetrain/static/img/nick-blue.jpg";
import sean from "@/../../hypetrain/static/img/sean-blue.jpg";
import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { Container } from "@/components/pieces/bootstrap";
import { StyledTitle } from "@/components/pieces/marketing/Titles";
import { HEADING_FONT, PURPLE_TEXT_COLOR } from "@/css/constants";

export function FounderLetter() {
  return (
    <Container className="!max-w-marketing-content">
      <CloudBox py={80}>
        <Box maxWidth={800} mx="auto">
          <Box
            backgroundColor="#FFF"
            className="round-corners"
            style={{ border: "1px solid #edf0f5" }}
            p={[24, 4, 48]}
          >
            <StyledTitle>Letter From The Founders</StyledTitle>
            <Box lineHeight="160%" fontSize={[20, 22]} mt={24}>
              <p>
                Nick and I share a fundamental conviction: the pursuit of
                excellence is part of a life well-lived. And work—by pushing the
                boundaries of our competence—provides the ideal environment to
                facilitate this drive.
              </p>
              <p>
                We've both personally witnessed how organizations thrive when
                everyone from the C-suite to the frontline commits to getting
                better each day. While these companies often set performance
                standards from the top, they recognize the importance of giving
                their people the guidance and tools to meet those expectations.
              </p>

              <p>
                The challenge to support growth and development has always been
                one of scale. The most powerful development tools have
                historically been impossible to democratize.
              </p>
              <p>
                At Exec, we intentionally created a platform that weaves
                together the best of human expertise with advanced AI to ensure
                the tools of excellence are accessible at scale. Whether you
                lead a team of ten or ten thousand, we believe that everyone who
                cares enough to improve deserves the resources to do so.
              </p>
              <p>
                We'd be honored to help you build an organization where
                excellence isn't the exception but the standard.
              </p>
              <p>
                Sincerely,
                <br />
                Sean Linehan & Nick deWilde
              </p>
              <Box mt={3}>
                <img src={founderSig} alt="Founders' Signatures" />
              </Box>
            </Box>
          </Box>
          <Flex mt={24} css={{ gap: 24 }} flexWrap={["wrap", "nowrap"]}>
            <Box
              width={["100%", 1 / 2]}
              backgroundColor="#FFF"
              className="round-corners"
              style={{ border: "1px solid #edf0f5" }}
              p={4}
            >
              <img src={sean} alt="Sean Linehan" />
              <Box
                mt={2}
                fontFamily={HEADING_FONT}
                fontSize={24}
                fontWeight={700}
                color={PURPLE_TEXT_COLOR}
              >
                About Sean
              </Box>
              <Box mt={1} fontWeight={500}>
                Co-Founder and CEO
              </Box>
              <Box mt={2}>
                <p>
                  Sean was previously the VP of Product at Flexport where he
                  helped the company grow from from 20 to 800 employees and $1M
                  to $500M in revenue.
                </p>
                <p>
                  As someone who’s experienced the power of work to unlock human
                  potential, Sean is passionate about helping individuals and
                  organizations grow.
                </p>
                <p>He holds a B.S. from University of California, Berkeley.</p>
              </Box>
            </Box>
            <Box
              width={["100%", 1 / 2]}
              backgroundColor="#FFF"
              className="round-corners"
              style={{ border: "1px solid #edf0f5" }}
              p={4}
            >
              <img src={nick} alt="Nick deWilde" />
              <Box
                mt={2}
                fontFamily={HEADING_FONT}
                fontSize={24}
                fontWeight={700}
                color={PURPLE_TEXT_COLOR}
              >
                About Nick
              </Box>
              <Box mt={1} fontWeight={500}>
                Co-Founder and CCO
              </Box>
              <Box mt={2}>
                <p>
                  Nick has over a decade of experience serving in roles across
                  the talent development industry. Previously, he led Product
                  Marketing at Guild Education during the company’s largest
                  growth phase.
                </p>
                <p>
                  Nick holds an MBA from Stanford GSB and has an audience of
                  over 12,000 readers who subscribe to the Jungle Gym, his
                  newsletter focused on professional development.
                </p>
              </Box>
            </Box>
          </Flex>
        </Box>
      </CloudBox>
    </Container>
  );
}

const CloudBox = styled(Box)`
  @media (min-width: ${breakpoints.sm}px) {
    background-image: url(${clouds});
    background-size: cover;
  }
`;
